export const FormattedNumber =(phone_number)=>{
    const formattedNumber = phone_number?.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
    return formattedNumber

}